import React from 'react';
import { Follow } from '../provider/FollowsProvider';

export interface FollowsContextType {
  follows: Follow[];
  getFollows: () => Follow[];
  isLoading: boolean;
  error: string | null;
  clearError: () => void;
}

export const FollowsContext = React.createContext<FollowsContextType>({
  follows: [],
  getFollows: () => [],
  isLoading: false,
  error: null,
  clearError: () => {},
});
